import React, { ChangeEvent } from 'react';
import { Select, Label, FluentProvider, webLightTheme } from '@fluentui/react-components';
import IDropdownOption from '../../../utils/types/IDropdownOption';

interface IMsReportingSalesYearSelectorProps {
  defaultValue: number;
  onChange: (
    event: ChangeEvent<HTMLSelectElement>,
    option?: IDropdownOption,
    index?: number,
  ) => void;
}

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() + 6);
const currentFiscalYear = currentDate.getUTCFullYear();
const options = [
  {
    key: currentFiscalYear,
    text: currentFiscalYear.toString(),
  },
  {
    key: currentFiscalYear + 1,
    text: (currentFiscalYear + 1).toString(),
  },
];

const MsReportingSalesYearSelector = ({
  defaultValue,
  onChange,
}: IMsReportingSalesYearSelectorProps): JSX.Element => {
  return (
    <FluentProvider theme={webLightTheme}>
      <Label id="msReportingSalesYear">MS Reporting Sales Year</Label>
      <Select
        aria-labelledby="msReportingSalesYear"
        defaultValue={defaultValue != null ? String(defaultValue) : ''}
        onChange={(event, data): void => {
          const value = data.value ? Number(data.value) : undefined;
          onChange(
            event,
            value !== undefined && !Number.isNaN(value)
              ? {
                  key: value,
                  text: options.find((option) => option.key === value)?.text || '',
                }
              : undefined,
            undefined,
          );
        }}
      >
        <option value="">-- Select Year --</option>
        {options.map((option) => (
          <option key={option.key} value={option.key}>
            {option.text}
          </option>
        ))}
      </Select>
    </FluentProvider>
  );
};

export default MsReportingSalesYearSelector;
